import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'app-bullet-step',
    templateUrl: './bullet-step.component.html',
    styleUrls: ['./bullet-step.component.scss']
})
export class BulletStepComponent {
    @Input() bageNumber = 0;
    @Input() bageName = '';
    @Input() text: string;
    @Input() isActive: boolean;
    @Input() isValid: boolean;
    @HostBinding('class.interaction') @Input() interaction = false;
}
